import React from 'react';
import { useWindowTitle } from '../../hooks';
import { tabsPath } from '../components';
export function useTabsState(navigationContext, navigate, location, initialTabs, onCloseTab, onCloseAllTabs, additionalTabBarActions) {
    var _a;
    const [tabs, setTabs] = React.useState(initialTabs);
    React.useEffect(() => {
        setTabs(tabs);
    }, [tabs]);
    const selectedTab = getSelectedTab(location.pathname, tabs);
    useWindowTitle((_a = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.label) !== null && _a !== void 0 ? _a : '', 5);
    return {
        selectedTabPath: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.path,
        tabs: tabs,
        setTabs: setTabs,
        handleOpenTab: (tab) => {
            navigationContext.navigate(() => {
                navigate(`${tabsPath}/` + tab.path);
            });
        },
        handleCloseTab: (closedTab, nextSelectedTab) => {
            navigationContext.navigate(() => {
                var _a;
                if (nextSelectedTab) {
                    navigate(`${tabsPath}/` + nextSelectedTab.path);
                }
                else {
                    if (selectedTab) {
                        navigate('/');
                    }
                }
                onCloseTab === null || onCloseTab === void 0 ? void 0 : onCloseTab(closedTab, nextSelectedTab);
                (_a = closedTab.onClose) === null || _a === void 0 ? void 0 : _a.call(closedTab, nextSelectedTab);
                setTabs((prevState) => (prevState !== null && prevState !== void 0 ? prevState : []).filter((tab) => tab.path !== closedTab.path));
            });
        },
        handleCloseAllTabs: () => {
            navigationContext.navigate(() => {
                if (selectedTab) {
                    navigate('/');
                }
                setTabs((prevState) => {
                    if (prevState) {
                        onCloseAllTabs === null || onCloseAllTabs === void 0 ? void 0 : onCloseAllTabs(prevState);
                        return [];
                    }
                    else {
                        return prevState;
                    }
                });
            });
        },
        additionalTabBarActions: additionalTabBarActions,
    };
}
function getSelectedTab(currentPath, tabs) {
    let selectedTab = undefined;
    if (currentPath.startsWith(`/${tabsPath}/`)) {
        const currentTabPath = currentPath.substring(tabsPath.length + 2);
        for (const tab of tabs !== null && tabs !== void 0 ? tabs : []) {
            if (currentTabPath === tab.path || currentTabPath.startsWith(tab.path + '/')) {
                selectedTab = tab;
                break;
            }
        }
    }
    return selectedTab;
}
